import classNames from "classnames";
import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { getUserData } from "utils/authService";

interface InternalLinkProp extends LinkProps {
  to: string;
  disabled?: boolean;
  noDisableClass?: boolean;
}

/**
 * InternalLink, A Component for rendering protected link.
 * It's a wrapper around the React Router Link component.
 *
 * If 'to' does not starts with '/u/tenantId/businessUnitId',
 * It prepends tenantId and businessUnitId to provided link.
 * @param props.to The destination URL for the link.
 * @param props...rest Rest of the Link props.
 * @returns JSX.Element Link Component from 'react-router-dom'
 */
export default function InternalLink({
  to,
  disabled,
  noDisableClass,
  className,
  ...rest
}: InternalLinkProp) {
  const userData = getUserData();

  const prePath = `/u/${userData.tenantId}/${userData.businessUnitId}`;
  const prependTo = to.startsWith(prePath) ? to : `${prePath}${to}`;

  // rendering blank anchor tag for disabled link as `to` is compulsary for Link
  if (disabled) {
    return (
      <a
        className={classNames(className, noDisableClass ? "" : "disabled")}
        {...rest}
      >
        {rest.children}
      </a>
    );
  }

  return <Link to={prependTo} {...rest} className={className} />;
}

export const buildUrl = (path: string) => {
  const userData = getUserData();
  const prePath = `/u/${userData.tenantId}/${userData.businessUnitId}`;
  return path.startsWith(prePath) ? path : `${prePath}${path}`;
};
